/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/offer';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SearchOffersRequest": {
                "fields": {
                  "filter": {
                    "type": ".squareup.corporate_card.service.SearchOffersRequest.Filter",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Filter": {
                    "fields": {
                      "merchantIds": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "activeOnly": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "excludeFullOfferDetails": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SearchOffersResponse": {
                "fields": {
                  "offers": {
                    "type": ".squareup.corporate_card.resources.Offer",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchOffersRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchOffersRequest?.nested?.Filter && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchOffersResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchOffersRequest @ squareup/corporate_card/service/search_offers.proto at 9:1
 */
export const SearchOffersRequest = $root.lookupType('squareup.corporate_card.service.SearchOffersRequest');
fixType(SearchOffersRequest);
Builder.createAndAttachToType(SearchOffersRequest);
/**
 * SOURCE Filter @ squareup/corporate_card/service/search_offers.proto at 10:3
 */
SearchOffersRequest.Filter = $root.lookupType('squareup.corporate_card.service.SearchOffersRequest.Filter');
fixType(SearchOffersRequest.Filter);
Builder.createAndAttachToType(SearchOffersRequest.Filter);
/**
 * SOURCE SearchOffersResponse @ squareup/corporate_card/service/search_offers.proto at 24:1
 */
export const SearchOffersResponse = $root.lookupType('squareup.corporate_card.service.SearchOffersResponse');
fixType(SearchOffersResponse);
Builder.createAndAttachToType(SearchOffersResponse);